import { useState, useEffect } from "react";
import { Row, Col, Button, Form } from "react-bootstrap";
import NewModal from "../../../../../shared/Modals/NewModal";
import crudApi from "@serie3/common/api/crudApi";
import GroupConfig from "@serie3/common/Modules/Groups/Resources/Endpoints";

const DeleteModal = ({ group, show, setShow }) => {
  const [inputValue, setInputValue] = useState("");

  const handleDelete = async () => {
    const response = await crudApi.del(GroupConfig.endpoints.delete, group?.id);
    if (response.ok) {
      alert("The Group will be deleted in 7 days");
    }
    setShow(false);
  };

  useEffect(() => {
    if (show) {
      setInputValue("");
    }
  }, [show]);

  const ExtraButton = () => {
    const isMatch = inputValue.trim() === group?.name.trim();

    return (
      <Button
        variant="danger"
        disabled={!isMatch}
        onClick={(e) => {
          e.preventDefault();
          if (isMatch) {
            handleDelete();
          }
        }}
      >
        Delete Group
      </Button>
    );
  };

  return (
    <NewModal show={show} setShow={setShow} ExtraButton={ExtraButton}>
      <Row>
        <Col>
          <p className="mb-2">
            Please type <strong>{group?.name}</strong> to confirm deletion:
          </p>
          <Form.Control
            type="text"
            placeholder="Enter group name"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
          />
        </Col>
      </Row>
    </NewModal>
  );
};

export default DeleteModal;
